module.exports = __webpack_public_path__ + "static/shape-right-cccb948e962615d13fff65a8cf1b06db.png";